<template>
    <div class="deground">
      <div class="adaptation flex justify-between align-start">
        <div
          class="bg-white" v-loading="loading"
          style="width: 100%; padding: 20px 30px; border-radius: 10px"
        >
          <div class="">
            <div class="" v-if="typelist.length">
              <div class="box2_until">
                <div
                  v-for="(item, index) in typelist"
                  :key="index"
                  class="borbot"
                  style="margin-bottom: 10px"
                >
                  <div class="box2_until_center">
                    <div class="box2_until_left">{{ item.name }}:</div>
                    <div class="box2_cent">
                      <div
                        v-for="(citem, cindex) in item.union_type"
                        @click.stop="
                          tochoose(
                            index,
                            cindex,
                            citem.id,
                            citem.name,
                            item.id,
                            citem.pid
                          )
                        "
                        :key="cindex"
                        class="box2_until_right cpoint"
                        :class="citem.checked ? 'sty' : ''"
                      >
                        {{ citem.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="shenbaoleft">
              <ul>
                <li
                  v-for="(item, index) in tablist"
                  :key="index"
                  @click="tochange(index, item.type)"
                  class="search cpoint"
                  :class="item.checked ? 'active1' : ''"
                >
                  {{ item.title }}
                </li>
              </ul>
            </div>
            <div class="shenbaoright"  >
                <div class="box5 box2_cc">
                  <div class="box5_text1 text-cut">政策名称</div>
                  <div class="box5_text2 text-cut">发布等级</div>
                  <div class="box5_text2 text-cut">发布区域</div>
                  <div class="box5_text2 text-cut">发布日期</div>
                  <div class="box5_text2 text-cut">截止日期</div>
                  <div class="box5_text2 text-cut">剩余天数</div>
                  <div class="box5_text3 text-cut">操作</div>
                </div>
                <div style="min-height: 550px;">
                  <div v-for="(item, index) in rightlist" :key="index" class="box5">
                    <div class="box5_text1">
                      {{ item.title }}
                    </div>
                    <div class="box5_text2">
                      <span v-if="item.type == 0">国家级</span>
                      <span v-if="item.type == 1">省级</span>
                      <span v-if="item.type >= 2">市级</span>
                    </div>
                    <div class="box5_text2">{{ item.city_name ? item.city_name + (item.area_name ? item.area_name : '') : '--' }}</div>
                    <div class="box5_text2">{{ item.use_start_time ? item.use_start_time : '--' }}</div>
                    <div class="box5_text2">{{ item.use_end_time ? item.use_end_time : '--' }}</div>
                    <div class="box5_text2">{{ item.day >= 0 ? '剩余' + item.day + '天' : '已截止' }}</div>
                    <div
                      class="box5_text3 text-cut cpoint"
                      @click="todetail('detail', item.id, 1)"
                    >
                      <div class="box2_nei">查看详情</div>
                    </div>
                  </div>
                  <template v-if="rightlist.length==0">
                    <Nomore></Nomore>    
                </template>
                </div>
              <div class="text-center pagecss" style="padding-top: 20px;">
                <el-pagination
                  background
                  :page-size="pagesize"
                  :hide-on-single-page="true"
                  layout="prev, pager, next"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :total="totalnum"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
import Nomore from '../../components/nomore.vue';
  export default {
    data() {
        return {
            query: "",
            navtype: 0,
            bg: "#ff9700",
            tablist: [
                {
                    title: "全部",
                    checked: true,
                    type: 4,
                },
                {
                    title: "国家级",
                    checked: false,
                    type: 0,
                },
                {
                    title: "省级",
                    checked: false,
                    type: 1,
                },
                {
                    title: "郑州",
                    checked: false,
                    type: 2,
                },
                
                {
                  title: "高新区",
                  checked: false,
                  type: 3,
                },
            ],
            rightlist: [],
            type: 4,
            totalnum: null,
            pagesize: 20,
            currentPage: 1,
            advertiselist: [],
            typelist: [],
            city: "",
            area: "",
            loading:true
        };
    },
    methods: {
        todetail(name, id, type) {
            this.$router.push({ name: name, query: { type: type, id: id } });
        },
        handleCurrentChange: function (currentPage) {
            this.currentPage = currentPage;
            // console.log(this.currentPage)  //点击第几页
            // this.rightlist = [];
            this.getlist();
        },
        handleSizeChange(size) {
            // this.pagesize = size;
            console.log(123123123);
            console.log(size); //每页下拉显示数据
        },
        tochange(index, type) {
            for (let i in this.tablist) {
                this.tablist[i].checked = false;
            }
            this.tablist[index].checked = true;
            this.type = this.tablist[index].type;
            // this.rightlist = [];
            this.getlist();
            if (type == 2) {
                // this.gettypelist(20);
            }
            else {
                this.typelist = [];
                this.city = "";
                this.area = "";
            }
        },
        tonextpage(name, id) {
            // var url = e.currentTatget.url
            this.$router.push({ name: name, params: { id: id } });
        },
        getlist() {
            this.loading = true
            var api = this.$api.api.index.noticeList;
            this.$https.post({
                api: api,
                type: "formData",
            }, {
                page: this.currentPage,
                type: this.type,
                page_size: 20,
                city: this.city,
                area: this.area
            }, (response) => {
                // console.log('12333333333333',response.data)
                this.totalnum = response.total_count;
                this.rightlist = response.data;
                this.loading = false
            }, (error) => {
                console.log(error);
            });
        },
        gettypelist(id) {
            var api = this.$api.api.index.get_city_area; //分类列表
            this.$https.post({
                api: api,
                type: "formData",
            }, {
                id: id,
            }, (response) => {
                if (id == 20) {
                    var list = [];
                    var arr = {
                        name: "地区",
                        union_type: [],
                        id: 0,
                    };
                    list.push(arr);
                    list[0].union_type = response.data;
                    list[0].union_type.unshift({
                        name: "全部",
                        id: 0,
                        checked: true,
                        pid: 0,
                    });
                    this.typelist = list;
                }
                else {
                    var arr = {
                        name: "区域",
                        union_type: [],
                        id: 0,
                    };
                    this.typelist[1] = arr;
                    this.typelist[1].union_type = response.data;
                    this.typelist[1].union_type.unshift({
                        name: "全部",
                        id: "all",
                        checked: true,
                        pid: "all",
                    });
                }
                this.$forceUpdate();
                // this.getlist();
            }, (error) => {
                console.log(error);
            });
        },
        tochoose(index, cindex, cid, name, id, pid) {
            for (let i in this.typelist[index].union_type) {
                this.typelist[index].union_type[i].checked = false;
            }
            console.log(index, cindex, cid, name, id);
            this.typelist[index].union_type[cindex].checked = true;
            if (pid == 0) {
                this.area = "";
                this.city = "";
                this.typelist.splice(1, 1);
            }
            else if (pid == 20) {
                this.gettypelist(cid);
                this.city = cid;
                this.area = "";
            }
            else {
                if (cid == "all") {
                    this.area = 0;
                }
                else {
                    this.area = cid;
                }
            }
            this.rightlist = [];
            this.currentPage = 1;
            this.getlist();
            this.$forceUpdate();
        },
    },
    created() {
        this.getlist();
    },
    components: { Nomore }
};
  </script>
  <style scoped>
  .weizhi {
    width: 1000px;
    overflow: hidden;
    margin: 0 auto;
  }
  .zuixin {
    height: 85px;
  }
  .zx-line {
    display: block;
    float: left;
    width: 4px;
    height: 21px;
    background-color: #0070c0;
    margin-top: 33px;
    margin-right: 15px;
    margin-left: 35px;
  }
  .newszc {
    float: left;
    font-size: 16px;
    line-height: 85px;
  }
  .shenbaoA {
    width: 1350px;
    margin: 20px auto;
    height: auto;
    /* overflow: hidden; */
    /* margin-top: 20px; */
    margin-bottom: 40px;
  }
  .shenbaoleft {
    width: 120px;
    height: auto;
    overflow: hidden;
    float: left;
    margin-right: 20px;
    background-color: #eee;
  }
  .shenbaoright {
   width: calc(100% - 140px);
    height: auto;
    overflow: hidden;
    float: left;
  }
  .shenbaoleft li {
    width: 118px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .shenbaoleft ul {
    border: 1px solid #e5e5e5;
  }
  .shenbaoleft .active1 {
    background: #fff;
    color: #0070c0;
    border-left: 2px solid #0070c0;
    /* width: 116px; */
  }
  .shenbaoright ul {
    border: 1px solid #eee;
    padding: 0 10px;
    min-height: 742px;
    /* height: 700px; */
    /* overflow-x: hidden;
          overflow-y: auto; */
  }
  .shenbaoright li {
    border-bottom: 1px dashed #eee;
    line-height: 36px;
    position: relative;
  }
  /*.shenbaoright li:last-child{*/
  /*    border-bottom:none;*/
  /*}*/
  .shenbaoright li span {
    position: absolute;
    top: 0;
    right: 0;
  }
  .sr_b {
    position: relative;
    margin-bottom: 30px;
  }
  .sr_btn {
    border: 1px solid #eee;
    border-radius: 5px;
    width: 175px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    margin-top: 30px;
  }
  .fan {
    display: flex;
    position: absolute;
    right: 15px;
    top: 0;
    height: 32px;
    align-items: center;
  }
  .fan em {
    border-radius: 3px;
    margin: 0;
    border: 1px solid #eee;
    height: 18px;
    width: 32px;
    text-align: center;
    line-height: 18px;
    margin: 0 5px;
  }
  .fan p {
    margin: 0;
    line-height: 18px;
  }
  .fan span {
    display: block;
    width: 18px;
    height: 18px;
    border: 1px solid #eee;
    text-align: center;
    line-height: 18px;
    border-radius: 3px;
  }
  .danhang {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .box1_header {
    display: flex;
    /* height: 55px; */
    padding: 0 15px;
    align-items: center;
    /* border-bottom: 1px solid #eee; */
  }
  
  .box1_header_text {
    font-size: 20px;
    color: #111111;
    font-weight: 600;
    margin-left: 10px;
  }
  
  .box1_header_shu {
    width: 4px;
    height: 21px;
    background-color: #0070c0;
  }
  .box2_until_center {
    display: flex;
  }
  
  .box2_until_left {
    font-size: 14px;
    color: #959595;
    width: 65px;
    line-height: 28px;
  }
  
  .box2_until_right {
    height: 28px;
    font-size: 14px;
    line-height: 28px;
    padding: 0 8px;
    color: #4e4e4e;
    margin-left: 22px;
    margin-bottom: 10px;
  }
  .borbot {
    border-bottom: 1px solid #eee;
  }
  .box2_cent {
    display: flex;
    width: 93%;
    flex-wrap: wrap;
    min-height: 38px;
  }
  .sty {
    color: #ffffff;
    background: #0070c0;
  }
  .cright{
     position: sticky;
    /* top: 166px; */
    top: 20px;
  }
  
  
  
  .box5 {
    width: 100%;
    display: flex;
    min-height: 50px;
    border-bottom: 1px solid #f1f1f1;
  }
  
  .box5_text1 {
    width: 31%;
    display: flex;
    align-items: center;
    border-right: 1px solid #f1f1f1;
    border-left: 1px solid #f1f1f1;
    padding: 5px;
  }
  
  .box5_text2 {
    width: 14%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    padding: 5px;
  }
  
  .box5_text3 {
    width: 13%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    padding: 5px;
  }
  .sty {
    color: #ffffff;
    background: #0070c0;
  }
  .box2_cc {
    color: #ffffff;
    background-color: #0070c0;
  }
  .box2_nei {
    /* width: 95px; */
    height: 30px;
    padding: 0 15px;
    /* background-color: #ff6c00; */
    background-color: #0160a3;
    color: #ffffff;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  </style>
  


// WEBPACK FOOTER //
// bulletin.vue?77cdb179